import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import VisibilityIcon from "@material-ui/icons/Visibility";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { orderApi } from "functions/apis";

import { formatDateTime } from "functions/Helper";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const sortOptionsList = [
  "No ASC",
  "No DESC",
  "Transaction Time ASC",
  "Transaction Time DESC"
];

const useStyles = makeStyles(styles);

export default function CancellationRejectedOrderList() {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [filter, setFilter] = React.useState({
    searchString: null,
    cancellationStatus: 3,
    sort: 19
  });
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    setLoading(true);
    orderApi
      .get("/Orders", {
        signal: source.current.signal,
        params: {
          filter: filter,
          pagination: pagination
        }
      })
      .then(data => {
        setData(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <Link to={"/admin/OrderCancellations/Detail/" + record.id}>
                    <Button color="info" className="like">
                      <VisibilityIcon /> View
                    </Button>
                  </Link>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [pagination, filter]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleSortChanged = e =>
    setFilter({
      ...filter,
      sort: e.target.value === "" ? null : e.target.value
    });

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              ORDER - CANCELLATION REJECTED
            </h4>
          </CardHeader>
          <CardBody>
            <GridItem xs={12}>
              <FormControl fullWidth className={classes.selectFormControl}>
                <InputLabel
                  htmlFor="selSortOptions"
                  className={classes.selectLabel}
                >
                  SORT BY
                </InputLabel>
                <Select
                  inputProps={{
                    id: "selSortOptions",
                    name: "selSortOptions"
                  }}
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  value={filter.sort ?? ""}
                  onChange={handleSortChanged}
                >
                  {sortOptionsList.map((record, key) => (
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value={key}
                      key={record}
                    >
                      <p>{record}</p>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleSearchStringChanged,
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  Header: "No",
                  accessor: "no"
                },
                {
                  id: "agent",
                  Header: "Agent",
                  accessor: d => d.agent.name
                },
                {
                  id: "voucherType",
                  Header: "Voucher Type",
                  accessor: d => d.voucherType.code
                },
                {
                  Header: "Quantity",
                  accessor: "quantity"
                },
                {
                  Header: "Reason",
                  accessor: "cancellationReason"
                },
                {
                  id: "cancellationRequestedAt",
                  Header: "Requested At",
                  accessor: d =>
                    formatDateTime(new Date(d.cancellationRequestedAt + "Z"))
                },
                {
                  id: "cancellationRejectedAt",
                  Header: "Rejected At",
                  accessor: d =>
                    formatDateTime(new Date(d.cancellationRejectedAt + "Z"))
                },
                {
                  Header: "Reject By",
                  accessor: "cancellationRejectedBy"
                },
                {
                  Header: "Reject Reason",
                  accessor: "cancellationRejectReason"
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
